import time from 'utils/time';
import normalize from 'components/Dashboard/utilities/normalizeString';
import resolveDynamicFilterName from 'components/Dashboard/utilities/resolveDynamicFilterName';

const setFilterHashes = (props) => {
  const {
    sortFilter,
    unreadFilter,
    searchFilter,
    filtersToCompile,
    sortModeFilter,
    toggleFilters,
    toggleFilter,
    dateFilter,
    parliamentaryFilters,
    tagsIsNotFilter,
    nationsFilter,
    topicPickerFilter,
    singleSelectFilters,
    state,
  } = props;
  let hashes = [''];

  if (unreadFilter && unreadFilter.value) {
    hashes.push('unread-only');
  }

  if (sortFilter && !sortFilter.hidden) {
    let optionSelected = sortFilter.options.find((item) => item.name === sortFilter.optionSelected);
    hashes[0] = optionSelected && optionSelected.hash ? optionSelected.hash : normalize(sortFilter.optionSelected);
  } else if (sortModeFilter && sortModeFilter.optionSelected && typeof sortModeFilter.optionSelected === 'string') {
    hashes[0] = normalize(sortModeFilter.optionSelected);
  }
  //DATE HASHES
  if (dateFilter && dateFilter.optionSelected !== '' && !dateFilter.hidden) {
    let dateOptionSelected = dateFilter.options.find((date) => date.name === dateFilter.optionSelected);
    let { prefix } = dateFilter;
    let { showCalendar, name, hash } = dateOptionSelected;
    if (showCalendar) {
      let dates = dateOptionSelected.dates.split(',');
      hashes.push(
        `${prefix ? `${prefix}:` : ''}${normalize(hash ? hash : name)}-${time(
          dates.length > 1 ? dates[0].slice(0, -1) : dates[0]
        ).formatCalendarDate()}${dates.length > 1 ? `-and-${time(dates[1].substring(1, dates[1].length)).formatCalendarDate()}` : ''}`
      );
    } else {
      hashes.push(normalize(name));
    }
  }

  const togglesForHash = toggleFilters?.length
    ? toggleFilters
    : toggleFilter
      ? [toggleFilter]
      : [];
  togglesForHash.forEach((tf) => {
    if (tf && tf.value && !tf.hidden) {
      hashes.push(normalize(tf.name));
    }
  });

  if (nationsFilter) {
    let optionSelected = nationsFilter.options.find((item) => item.name === nationsFilter.optionSelected);
    if (optionSelected) {
      hashes.push(normalize(optionSelected.name));
    }
  }

  //Parliamentary filters

  if (parliamentaryFilters) {
    parliamentaryFilters.options.forEach((option) => {
      const { selectedOptions, selected, options, houseFilter, houseFilterSelectedOptions } = option;
        if (selected) {
        //PLAIN FILTERS
        selectedOptions.forEach((suboption) => {
          const suboptionSelected = options.find((item) => item.name === suboption);
          const { hash, name, nestedOptions, options: legacyNestedOpts, selectedNestedOptions } = suboptionSelected;
          const nestedOpts = nestedOptions ?? legacyNestedOpts;
          if (nestedOpts?.length && selectedNestedOptions?.length) {
            if (selectedNestedOptions.length === nestedOpts.length) {
              hashes.push(hash ?? normalize(name));
            } else {
              selectedNestedOptions.forEach((nestedName) => {
                const nestedItem = nestedOpts.find((n) => n.name === nestedName);
                hashes.push(nestedItem.hash ?? normalize(nestedItem.name));
              });
            }
          } else {
            hashes.push(hash ?? normalize(name));
          }
        });
        //HOUSES
        if (houseFilter) {
          houseFilterSelectedOptions.forEach((houseFilterSelected) => {
            const houseOptionSelected = houseFilter.options.find((item) => item.name === houseFilterSelected);
            const { hash, name } = houseOptionSelected;
            hashes.push(hash ?? normalize(name));
          });
        }
      }
    });
  }

  if (tagsIsNotFilter) {
    filtersToCompile.push(tagsIsNotFilter);
  }

  //Common filters
  filtersToCompile.forEach((filter) => {
    let { options, hidden, updateHash } = filter;
    options
      .filter((option) => !option.disabled)
      .forEach((option) => {
        let { suboptions, selected, hash, name, optionSelected } = option;
        // Some option names are `${path.to.value}` templates resolved against global state (e.g.
        // the Initiator filter's Organisation/Team options) - has to resolve here the same way
        // CommonFilter.jsx resolves it for display, or the hash won't match what gets read back on load.
        const resolvedName = resolveDynamicFilterName(name, state);
        if (selected && (!hidden || updateHash)) {
          hashes.push(
            `${filter?.prefix ? `${filter.prefix}:` : ''}${
              filter.type === 'membership' || (filter.filterName === 'tags' && !filter.notUseTagsConfig)
                ? encodeURIComponent(hash ?? resolvedName)
                : (hash ?? normalize(resolvedName))
            }`
          );
          //AE: It seems this part is only being applied for legislation goverment bills hash
          if (optionSelected && !optionSelected.startsWith('All')) {
            let subHash = suboptions.find((suboption) => suboption.name === optionSelected);
            hashes.push(subHash.hash ?? normalize(subHash.name));
          }
        }
      });
  });

  if (singleSelectFilters?.length > 0) {
    singleSelectFilters.forEach((filter) => {
      if (filter?.hidden) return;
      let selectedName = filter?.optionSelected;
      if (!selectedName) return;
      let selectedOption = filter?.options?.find((option) => option?.name === selectedName);
      if (selectedOption?.disabled) {
        selectedName = filter.options.find((o) => !o.disabled)?.name ?? 'Document';
        selectedOption = filter?.options?.find((option) => option?.name === selectedName);
      }
      const optionHash = selectedOption?.hash ?? normalize(selectedName);
      hashes.push(`${filter?.prefix ? `${filter.prefix}:` : ''}${optionHash}`);
    });
  }

  if (searchFilter && searchFilter.value !== '') {
    hashes.push(`search-within:${encodeURIComponent(searchFilter.value)}`);
  }

  if (topicPickerFilter) {
    const { options, sentiment } = topicPickerFilter;
    options.forEach((option) => {
      let { selected, id } = option;
      if (selected) {
        hashes.push(`${sentiment ? sentiment : 'vocal'}-about:${id}`);
      }
    });
  }

  return hashes.join('~');
};

export { setFilterHashes };
